/**
 * extras list controller, used for managing the list view of all extras
 */
angular.module('bookingApp')
    .controller('extrasListController', function ($scope, $http, $filter, $routeParams, propertyFactory) {
    // setup footer controls
    $scope.setupStandardCartFooter();
    $scope.footer.nextFunc = nextFunc;
    propertyFactory.showRedirectConfirm = true;
    // sk-extra click functionality
    $scope.goToExtra = goToExtra;
    // retrieve the extras
    $scope.getExtras = getExtras;

    // setup extra only footer controls
    if($scope.property.isItemOnly){
        $scope.setupItemOnlyFooter();
        $scope.footer.display.prev = false;
        if(property.isItemOnly && cart.bookingExtras.selected.length === 0){
            $scope.footer.disabled.next = true;
        } else {
            $scope.footer.disabled.next = false;
        }
    }

    // setup selected room
    if(typeof $routeParams.roomId !== 'undefined') {
        $scope.session.configureRoomIndex = $routeParams.roomId;
    } else {
        if(!property.isItemOnly) {
            // get the index of the first room in the last carted room's group
            var selectedGroupIndex = null;
            if ($scope.cart && $scope.cart.rooms && $scope.cart.rooms[$scope.cart.rooms.length - 1]){
                selectedGroupIndex = $scope.cart.rooms[$scope.cart.rooms.length - 1].roomGroupIndex;
            }
            var count = 0;
            var index = 0;
            var found = [];
            angular.forEach(cart.rooms, function (room) {
                if (room.roomGroupIndex === selectedGroupIndex && found.indexOf('group' + room.roomGroupIndex) === -1) {
                    found.push('group' + room.roomGroupIndex);
                    index = count;
                }
                count++;
            });
            $scope.session.configureRoomIndex = index; //$scope.cart.rooms.length - 1;
        }
    }
    // check if extras are already loaded and load if not
    if (!(typeof $scope.extras === "undefined")) {
        $scope.getExtras();
    }

    function nextFunc(){
        $scope.goToCart();
    }

    function getExtras() {
        $scope.session.isLoading = true;
        $http.get('/front-booking/api-extras/',
            {
                params: {
                    bc: $scope.property.id,
                    sid: $scope.session.sid,
                    templateID: $scope.property.template.id,
                    dateIn: $filter('date')($scope.session.selectedFilters.checkin, 'yyyy-MM-dd'),
                    dateOut: $filter('date')($scope.session.selectedFilters.checkout, 'yyyy-MM-dd'),
                    format: 'json'
                }
            }
        ).success(function (data, status, headers, config) {
                // assign extras to the extras factory
                $scope.extras.extras = data.extras;
                $scope.extras.extrasPrices = data.extrasPrices;
                $scope.extras.extrasPhotos = data.extrasPhotos;
                $scope.extras.extraCategories = data.extraCategories;
                $scope.session.isLoading = false;
            }).error(function (data, status, headers, config) {
                $scope.logError('error retrieving extras', {status: status, headers: headers});
                // display error to the user
                $scope.showError('Whoops', 'It appears that your session has expired. Please try clearing your browser cache and refreshing', true);
                // remove the loader
                $scope.session.isLoading = false;
            });
    }

    function goToExtra(categoryIndex, extraIndex) {
        var priceOb = $scope.extras.checkPricing(categoryIndex, extraIndex, $scope.session.selectedFilters.checkin, $scope.session.selectedFilters.checkout, 1, $scope.extras.extras, $scope.extras.extrasPrices)
        if(priceOb.priceFrom !== null){
            $scope.goToPage('category/' + categoryIndex + '/extra/' + extraIndex);
        }
    }
});